import { render, staticRenderFns } from "./rundev.vue?vue&type=template&id=64d0a396&"
import script from "./rundev.vue?vue&type=script&lang=js&"
export * from "./rundev.vue?vue&type=script&lang=js&"
import style0 from "./rundev.vue?vue&type=style&index=0&id=64d0a396&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports